export enum KnowledgeBaseDataEventObject {
  KB_PLUGIN = 'kb_plugin',
  KB_PLUGIN_UPSELL = 'kb_plugin_upsell',
  KB_FULL_SCREEN_UPSELL = 'kb_full_screen_upsell',
  URL_IMPORTER_CONSENT = 'url_importer_consent',
  KB_IMPORT_ERROR_DIALOG = 'kb_import_error_dialog',
  KB_IMPORT_ERROR_DIALOG_DISMISS_CATEGORIES = 'kb_import_error_dialog_dismiss_categories',
  KB_IMPORT_ERROR_DROPDOWN = 'kb_import_error_dropdown',
  KB_IMPORT_ERROR_IMAGE_DROPDOWN = 'kb_import_error_image_dropdown',

  KB_CONTENT = 'content',
  KB_SETTINGS = 'settings',
  KB_SETTINGS_TAB = 'settings_tab',
  KB_SETTINGS_VIEW_SITE = 'view_site',
  KB_SETTINGS_PRIMARY_BUTTON = 'primary_button',
  KB_PORTAL_SETTINGS_TOGGLE = 'enable_portal',
  KB_PORTAL_SETTINGS_PORTAL_CHANNEL = 'portal_channel',
  KB_PORTAL_SETTINGS_CHANNEL_SETTINGS = 'go_to_channel_settings',
  KB_RESOLVE_SETTINGS_CHANNEL = 'resolve_channel',
  KB_DISCARD_CHANGES = 'discard_changes',

  KB_PLUGIN_ASK_AI = 'kb_plugin_ask_ai',
  KB_PLUGIN_ASK_AI_BAR = 'kb_plugin_ask_ai_bar',
  KB_PLUGIN_ASK_AI_SEND = 'kb_plugin_ask_ai_send',
  KB_PLUGIN_ASK_AI_CLEAR = 'kb_plugin_ask_ai_clear',
  KB_PLUGIN_ASK_AI_SOURCE = 'kb_plugin_ask_ai_source',
  KB_PLUGIN_ASK_AI_COPY_RESPONSE = 'kb_plugin_ask_ai_copy_response',
  KB_PLUGIN_ASK_AI_FEEDBACK = 'kb_plugin_ask_ai_feedback',

  KB_FORM_CHANNEL_DIALOG_GENERAL_STEP = 'kb_form_channel_dialog_general_step',
  KB_FORM_CHANNEL_DIALOG_FORM_FIELDS_STEP = 'kb_form_channel_dialog_form_fields_step',
  KB_FORM_CHANNEL_DIALOG_PREVIEW_STEP = 'kb_form_channel_dialog_preview_step',
  KB_FORM_CHANNEL_DIALOG_FOOTER_CANCEL = 'kb_form_channel_dialog_footer_cancel',
  KB_FORM_CHANNEL_DIALOG_FOOTER_SAVE = 'kb_form_channel_dialog_footer_save',
}
